// extracted by css-extract-rspack-plugin
export default {"activityBadge":"Activity_activityBadge__mDz8a","badgeImg":"Activity_badgeImg__1okd2"};